import { sortBy } from "lodash";
import { PureComponent, ReactNode } from "react";
import { connect } from "react-redux";
import { RouteComponentProps } from "react-router-dom";
import { Dispatch } from "redux";

import Redirect from "components/Redirect";
import { Right } from "constants/right";
import { IStoreState } from "interfaces/storeState";
import { AgentsRoutes } from "routes/agents/constants";
import { SettingsRoutes } from "routes/settings/constants";
import { IKeyAny } from "services/api/api-client";
import { selectAgentsAlphabetically } from "store/entities/agents";
import { selectContactForms } from "store/entities/contact-forms/selectors";
import { selectLicenseId } from "store/entities/license";
import { selectMailboxesAlphabetically } from "store/entities/mailboxes/selectors";
import { selectReplyAddresses } from "store/entities/reply-addresses/selectors";
import { UpdateTeamForm, selectDefaultTeamName, selectTeam } from "store/entities/teams";
import { hasRight } from "store/features/session";
import { TeamsViewActions, selectCanAddTeams } from "store/views/teams";

import TeamForm, { ITeamFormProps } from "./TeamForm";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const mapStateToProps = (state: IStoreState, ownProps: RouteComponentProps) => ({
  agents: selectAgentsAlphabetically(state),
  team: selectTeam(state, (ownProps.match.params as IKeyAny).id),
  replyAddresses: selectReplyAddresses(state),
  contactForms: selectContactForms(state),
  licenseID: selectLicenseId(state),
  canAddTeams: selectCanAddTeams(state),
  canManageTeams: hasRight(state, Right.ManageTeams),
  defaultTeamName: selectDefaultTeamName(state),
  mailboxes: selectMailboxesAlphabetically(state),
});

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const mapDispatchToProps = (dispatch: Dispatch) => ({
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  onSubmit: (team: UpdateTeamForm) => {
    const updatedTeam = { ...team, replyAddressID: team.replyAddressID || null, replyName: team.replyName || null };

    if (updatedTeam.id) {
      // @ts-expect-error TS(2345)
      dispatch(TeamsViewActions.updateTeam(updatedTeam));
    } else {
      // @ts-expect-error TS(2345)
      dispatch(TeamsViewActions.createTeam(updatedTeam));
    }
  },
  // FIXME: Fix this the next time the file is edited.
  // @ts-expect-error TS(2345)
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  onDelete: (teamId: string) => dispatch(TeamsViewActions.deleteTeam({ teamId })),
});

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;

interface IProps extends RouteComponentProps, StateProps, DispatchProps {}

class TeamFormContainer extends PureComponent<IProps> {
  constructor(props: IProps) {
    super(props);

    const teamId = (this.props.match.params as IKeyAny).id;
    if (teamId && !props.team) {
      this.props.history.push(AgentsRoutes.Teams);
    }
  }

  handleCancel = (): void => {
    this.props.history.push(AgentsRoutes.Teams);
  };

  handleGoToMailboxes = (): void => {
    this.props.history.push(SettingsRoutes.EmailAddress);
  };

  handleGoToContactForms = (): void => {
    this.props.history.push(SettingsRoutes.ContactForms);
  };

  render(): ReactNode {
    const {
      agents,
      team,
      canAddTeams,
      canManageTeams,
      defaultTeamName,
      mailboxes,
      licenseID,
      onSubmit,
      onDelete,
      replyAddresses,
      contactForms,
    } = this.props;

    const replyAddressesForForm = sortBy(Object.values(replyAddresses), r => -r.createdAt);

    const props: ITeamFormProps = {
      agents,
      team,
      defaultTeamName,
      mailboxes,
      replyAddresses: replyAddressesForForm,
      licenseID,
      contactForms,
      onSubmit,
      onCancel: this.handleCancel,
      onDelete,
      onGoToMailboxes: this.handleGoToMailboxes,
      onGoToContactForms: this.handleGoToContactForms,
      history: this.props.history,
      location: this.props.location,
      match: this.props.match,
    };

    if (!canManageTeams || (!team && !canAddTeams)) {
      return <Redirect to={AgentsRoutes.Teams} />;
    }

    return <TeamForm {...props} />;
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TeamFormContainer);
